"use client"
/* */
const modal = "flow--modal";
const offCanvas = "flow--modal--off-canvas";
const header = "flow--modal--header";
const content = "flow--modal--content";
const columnLayout = "flow--modal--column-layout";
const actionGroup = "flow--modal--action-group";
const accentBox = "flow--modal--accent-box";
const left = "flow--modal--left";
const styles = {
	modal: modal,
	offCanvas: offCanvas,
	header: header,
	content: content,
	columnLayout: columnLayout,
	actionGroup: actionGroup,
	accentBox: accentBox,
	"size-s": "flow--modal--size-s",
	"size-m": "flow--modal--size-m",
	"size-l": "flow--modal--size-l",
	"modal-zoom": "flow--modal--modal-zoom",
	"modal-slide-in-from-right": "flow--modal--modal-slide-in-from-right",
	left: left,
	"modal-slide-in-from-left": "flow--modal--modal-slide-in-from-left",
	"modal-slide-up": "flow--modal--modal-slide-up"
};

export { accentBox, actionGroup, columnLayout, content, styles as default, header, left, modal, offCanvas };
//# sourceMappingURL=Modal.module.scss.mjs.map
